"use client";

import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GalleryHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    setPrefersReducedMotion(mediaQuery.matches);
    const handleChange = (e: MediaQueryListEvent) => {
      setPrefersReducedMotion(e.matches);
    };
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);
  useEffect(() => {
    if (prefersReducedMotion) return;
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prefersReducedMotion]);
  const parallaxOffset = prefersReducedMotion ? 0 : scrollY * 0.2;
  return <section ref={ref} className="relative w-full h-screen overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-0" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1474184/img/image_w11rs8rn.webp)",
      transform: `translateY(${parallaxOffset}px)`
    }} />

      {}
      <div className="relative z-10 flex items-center justify-center w-full h-full px-4">
        <div className={`
            max-w-3xl w-full
            bg-primary-light/90 backdrop-blur-sm
            rounded-2xl shadow-strong
            px-8 py-12 md:px-16 md:py-20
            transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]
            hover:scale-[1.02] hover:shadow-[0_12px_48px_rgb(0_0_0_/_0.2)]
            ${isVisible && !prefersReducedMotion ? "opacity-100 translate-y-0" : !prefersReducedMotion ? "opacity-0 translate-y-5" : "opacity-100"}
          `} style={!prefersReducedMotion ? {
        transition: "opacity 200ms ease-out, transform 200ms ease-out, box-shadow var(--duration-medium) ease-out, scale var(--duration-medium) ease-out"
      } : {}}>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-center text-foreground-light mb-4 leading-tight">
            Authentic Mexican Flavors
          </h1>
          <p className="font-sans text-lg md:text-xl text-center text-foreground max-w-2xl mx-auto leading-relaxed">
            Discover the vibrant tastes of Texas Margaritas, where every dish
            is crafted with love and tradition in a warm, family-friendly
            atmosphere.
          </p>
        </div>
      </div>
    </section>;
}